import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { map, catchError } from 'rxjs/operators';
import { PartnerHttpClientService } from 'src/app/core/http/partner-http-client';
import { Store } from 'src/app/core/store/store';
import * as XLSX from "xlsx-js-style";
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  constructor(private http: PartnerHttpClientService, private store: Store) { }

  getOrganizations() {
    console.log('>>>>>>>>>>get organizations called');
    this.store.set('organizationLoader', true);
    return this.http.get<{}>('organizations').pipe(
      map(res => {
        this.store.set('organizationLoader', false);
        console.log('>>>>>>>>>>res');
        return res;
      }),
      catchError(err => {
        this.store.set('organizationLoader', false);
        return [err];
      })
    );
  }

  getActivations(organization: string) {
    console.log('>>>>>>>>>>get activations called');

    this.store.set('activationLoader', true);

    return this.http.get<{}>(`activations?organization=${organization}`).pipe(
      map(res => {
        this.store.set('activationLoader', false);

        console.log('>>>>>>>>>>res');
        return res;
      }),
      catchError(err => {
        this.store.set('activationLoader', false);

        return [err];
      })
    );
  }

  getDashboard(organization: string, activation: string) {
    console.log('>>>>>>>>>>get dashboard called');
    this.store.set('dashboardLoader', true);

    return this.http.get<{}>(`progDetails?organization=${organization}&activationId=${activation}`).pipe(
      map(res => {
        this.store.set('dashboardLoader', false);

        console.log('>>>>>>>>>>res');
        return res;
      }),
      catchError(err => {
        this.store.set('dashboardLoader', false);

        return [err];
      })
    );
  }

  getElements(organization: string, activation: string) {
    console.log('>>>>>>>>>>get elements called');

    this.store.set('elementLoader', true);

    return this.http.get<{}>(`elements?organization=${organization}&activationId=${activation}`).pipe(
      map(res => {
        this.store.set('elementLoader', false);

        console.log('>>>>>>>>>>res');
        return res;
      }),
      catchError(err => {
        this.store.set('elementLoader', false);

        return [err];
      })
    );
  }


  sanitizedString = (head: string, str: string) => {
    return (head === 'Description' || head === 'Review') ? `"${str}"` : str;
  }


  convertToCSVFromArray(objArray) {
    let str = '';
    for (let i = 0; i < objArray.length; i++) {
      let lineArray = objArray[i];
      let line = '';
      lineArray.forEach((lr, i) => {

        let l = lr ? lr : '';
        if (i === 0) {
          line += `"${l}"`;
        }
        else {
          line += `,"${l}"`;
        }

      });
      str += line + '\r\n';
    }
    return str;
  }


  convertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';
    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];
        line += ',' + this.sanitizedString(head, array[i][head]);
      }
      str += line + '\r\n';
    }
    return str;
  }

  downloadFile(data, headers = [], filename = 'data', isArray = false) {
    let csvData = isArray ? this.convertToCSVFromArray(data) : this.convertToCSV(data, headers);
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }


  downloadXlsx(data, filename) {
    let cols = 0;
    if(data?.length > 0){
        cols = Object.keys(data[0]).length;
    }


    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    for(let col = 0; col < cols; col++){
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
      worksheet[cellRef].s = {
        alignment: { horizontal: "center" },
        font: { bold: true }
      };
    }
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.writeFile(workbook, `${filename}.xlsx`);


  }

  downloadXlsxAoa(data, filename, merge, progress){
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet([]);

    const summaryWorksheet = XLSX.utils.json_to_sheet([]);
    let cols = 0;
    if(data?.length > 0){
        cols = data[0].length;
    }

    XLSX.utils.book_append_sheet(workbook, summaryWorksheet, 'Progress Summary');
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Learners');
    XLSX.utils.sheet_add_aoa(worksheet, data);
    XLSX.utils.sheet_add_aoa(summaryWorksheet, progress);

    // console.log('>>>>>>>>.download data', data);
    for(let col = 0; col < cols; col++){
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
      worksheet[cellRef].s = {
        alignment: { horizontal: "center" },
        font: { bold: true }
      };
      const cellRef2 = XLSX.utils.encode_cell({ r: 1, c: col });
      worksheet[cellRef2].s = {
        alignment: { horizontal: "center" },
        font: { bold: true }
      };
    }

    worksheet["!merges"] = merge;
    XLSX.writeFile(workbook, `${filename}.xlsx`);

  }

     /*
      *  Calculate Overall Progress function
      *
      *  Used in the Learner's page to include in the excel report and the Dashboard
      *  1. Create a habit drill map against a course that gives the no. of habitdrills per course
      *  2. For each learner and their progress in an element:
      *   Aggregate based on the type of element the numerators and denominators
      *  3. Divide the numerators and denominators
      *  4. In the UI, don't include scores < 0
      * Note: Habit drill responses are taken into consideration. A response is said to be present if the submission date is not null.
      *
      *
      */
  calculateOverallProgress = (elements) => {
    let progress = [0,0,0,0,0,0];
    let nullLearners = 0;
    if (elements?.learnerDetails) {


      const OVERALL = 0, PRE = 1, POST = 2, COURSE = 3, MASTERCLASS = 4, HABITDRILL = 5, ASSESSMENT = 6;
      let numArray = [-1, -1, -1, -1, -1, -1, -1];
      let denArray = [0, 0, 0, 0, 0, 0, 0];


      let habitDrillMap = {};

      elements.habitDrills.forEach((hd) => {
        if (habitDrillMap[hd.course_title]) {
          habitDrillMap[hd.course_title] = habitDrillMap[hd.course_title] + 1;
        }
        else {
          habitDrillMap[hd.course_title] = 1;
        }
      })


      elements.learnerDetails.forEach((l) => {
        numArray[OVERALL] = numArray[OVERALL] < 0 ? 0 : numArray[OVERALL];
        numArray[OVERALL] = l.progress && l.progress != 'null' ? numArray[OVERALL] + l.progress : numArray[OVERALL];
        if(!l.progress || l.progress == 'null'){
          nullLearners++;
        }
        if (l.type === 'ASSESSMENT') {
          numArray[ASSESSMENT] = numArray[ASSESSMENT] < 0 ? 0 : numArray[ASSESSMENT];
          numArray[ASSESSMENT] = l.iscompleted ? numArray[ASSESSMENT] + 1 : numArray[ASSESSMENT];
        }


        if (l.type === 'PRE') {
          numArray[PRE] = numArray[PRE] < 0 ? 0 : numArray[PRE];
          numArray[PRE] = l.iscompleted ? numArray[PRE] + 1 : numArray[PRE];
        }


        if (l.type === 'POST') {
          numArray[POST] = numArray[POST] < 0 ? 0 : numArray[POST];
          numArray[POST] = l.iscompleted ? numArray[POST] + 1 : numArray[POST];
        }

        if (l.type === 'COURSE') {
          numArray[COURSE] = numArray[COURSE] < 0 ? 0 : numArray[COURSE];
          numArray[COURSE] = l.progress ? numArray[COURSE] + l.progress : numArray[COURSE];
        }

        if (l.type === 'MASTERCLASS') {
          numArray[MASTERCLASS] = numArray[MASTERCLASS] < 0 ? 0 : numArray[MASTERCLASS];
          numArray[MASTERCLASS] = l.progress === 100 ? numArray[MASTERCLASS] + 1 : numArray[MASTERCLASS];
        }





      });


      const today = moment().valueOf();

      elements.elements.forEach((e) => {
        denArray[OVERALL] = denArray[OVERALL] + 1;

        const startDate = parseInt(e.startDate);

        if (e.type !== 'PRE' || e.type !== 'POST') {
          if (e.startDate && (isNaN(startDate) || startDate <= today)) {
            if (e.type === 'MASTERCLASS') {
              denArray[MASTERCLASS] = denArray[MASTERCLASS] + 1;
            }

            if (e.type === 'COURSE') {
              denArray[COURSE] = denArray[COURSE] + 1;
              denArray[HABITDRILL] = habitDrillMap[e.title] ? denArray[HABITDRILL] + habitDrillMap[e.title] : denArray[HABITDRILL];
            }

            if(e.type === 'ASSESSMENT'){
              denArray[ASSESSMENT] = denArray[ASSESSMENT] + 1;
            }
          }
        }

      });

      const learnerCount = elements.elements.length > 0 ? elements.learnerDetails.length / elements.elements.length : 0;

      denArray[OVERALL] = denArray[OVERALL] * learnerCount * 100;
      denArray[PRE] = learnerCount;
      denArray[POST] = learnerCount;
      denArray[COURSE] = denArray[COURSE] * learnerCount * 100;
      denArray[MASTERCLASS] = denArray[MASTERCLASS] * learnerCount;
      denArray[HABITDRILL] = denArray[HABITDRILL] * learnerCount;
      denArray[ASSESSMENT] = denArray[ASSESSMENT] * learnerCount;
      const actualLearners =elements.learnerDetails.length - nullLearners;
      progress[OVERALL] = numArray[OVERALL] >= 0 && actualLearners > 0 ? Math.round(numArray[OVERALL] / actualLearners) : -1;
      progress[COURSE] = numArray[COURSE] >= 0 && denArray[COURSE] > 0 ? Math.round(numArray[COURSE] * 100 / denArray[COURSE]) : -1;
      progress[MASTERCLASS] = numArray[MASTERCLASS] >= 0 && denArray[MASTERCLASS] > 0 ? Math.round(numArray[MASTERCLASS] * 100 / denArray[MASTERCLASS]) : -1;
      progress[PRE] = numArray[PRE] >= 0 && denArray[PRE] > 0 ? Math.round(numArray[PRE] * 100 / denArray[PRE]) : -1;
      progress[POST] = numArray[POST] >= 0 && denArray[POST] > 0 ? Math.round(numArray[POST] * 100 / denArray[POST]) : -1;
      progress[ASSESSMENT] = numArray[ASSESSMENT] >= 0 && denArray[ASSESSMENT] > 0 ? Math.round(numArray[ASSESSMENT] * 100 / denArray[ASSESSMENT]) : -1;

      const genuineResponses = elements.habitDrillResponses.filter((f) => f.hd_date_submission);


      if (genuineResponses && genuineResponses.length > 0) {
        numArray[HABITDRILL] = genuineResponses.length;
      }

      progress[HABITDRILL] = numArray[HABITDRILL] >= 0 && denArray[HABITDRILL] > 0 ? Math.floor(numArray[HABITDRILL] * 100 / denArray[HABITDRILL]) : -1;
    }

    return progress;
  }

  clearSession = () => {
    sessionStorage.clear();
  }


  calculateOverallHealth = (metrics) => {

  }


}
